import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 88,
	height: 88,
	viewBox: "0 0 88 88",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2185_847)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: .6875,
				y: 17.875,
				width: 86.625,
				height: 22,
				rx: 4,
				fill: "#ACD4FF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .6875,
				y: 48.125,
				width: 56.375,
				height: 22,
				rx: 4,
				fill: "#ACD4FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54.9562 68.9533C56.2386 67.9464 57.0624 66.3819 57.0624 64.625V53.625C57.0624 50.5874 54.6 48.125 51.5624 48.125H25.9313C26.279 49.8012 26.7962 51.468 27.4913 53.1038C32.1963 64.1744 43.5845 70.3588 54.9562 68.9533Z",
				fill: "#006ADC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.5508 39.875H77.9253C77.6472 37.394 77.009 34.9109 75.9825 32.4955C72.938 25.3318 67.095 20.2142 60.2689 17.875H43.2021C42.609 18.0788 42.0189 18.305 41.4328 18.5541C32.3683 22.4064 26.5796 30.7393 25.5508 39.875Z",
				fill: "#006ADC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61.1638 66.1055C74.4987 60.4383 80.7146 45.034 75.0474 31.6991C69.3802 18.3642 53.976 12.1483 40.6411 17.8155C27.3062 23.4827 21.0903 38.887 26.7575 52.2219C32.4247 65.5568 47.8289 71.7727 61.1638 66.1055Z",
				stroke: "#002E5F",
				strokeWidth: 4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.3555 60.6448L85.0221 75.3114",
				stroke: "#002E5F",
				strokeWidth: 4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2185_847",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 88,
			height: 88,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgSearchIcon);
export default ForwardRef;
